<nav
	class="topnav navbar navbar-expand justify-content-between justify-content-sm-start"
	[ngClass]="[isDark ? 'navbar-dark bg-dark' : 'navbar-light bg-white', platformService.mobile ? 'shadow-none' : 'shadow']">
	@if (appNative) {
		<!-- Modo app (spec 058): a navegação fica no menu inferior; aqui só o título da tela. -->
		<span class="topnav-app-title text-truncate">{{ pageTitle }}</span>
	} @else {
		@if (!multitenant) {
			<button
				class="btn btn-icon ms-1 d-block topnav-mobile-toggle"
				id="sidebarToggle"
				(click)="sideNav()"
				[style.background-color]="platformService.mobile ? 'transparent !important' : ''">
				<fa-icon [icon]="['fas', 'bars']"></fa-icon>
			</button>
		}

		<a class="navbar-brand pe-3 ps-4 ps-lg-3 d-sm-block d-none" [routerLink]="[linkBrand]">
			<img src="assets/img/logo-brand.png" class="img-fluid" alt="logo" />
			@if (multitenant) {
				<b class="ms-3">SilGov</b>
			}
		</a>
	}

	@if (!multitenant) {
		@if (
			accountService.isAppMember && accountService.hasSessionAccount && ![ProductType.SIG, ProductType.SUP].includes(accountService.currentProduct?.type)
		) {
			<sbpro-top-nav-tenant-select></sbpro-top-nav-tenant-select>
		}
	}

	<ul class="navbar-nav align-items-center ms-auto me-lg-4">
		<li class="nav-item">
			@if (!platformService.mobile) {
				<button
					class="btn btn-icon"
					[ngClass]="isDark ? 'btn-transparent-light' : 'btn-transparent-dark'"
					type="button"
					(click)="toggleTheme()"
					aria-label="Alternar tema"
					[attr.title]="isDark ? 'Ativar modo claro' : 'Ativar modo escuro'">
					@if (isDark) {
						<fa-icon [icon]="['fas', 'lightbulb']"></fa-icon>
					} @else {
						<fa-icon [icon]="['fas', 'moon']"></fa-icon>
					}
				</button>
			}
		</li>
		<sbpro-top-nav-messages></sbpro-top-nav-messages>
		<sbpro-top-nav-user [profileEditable]="!multitenant"></sbpro-top-nav-user>
	</ul>
</nav>
